import { useQuery } from '@tanstack/react-query';
import { affiliateService } from '../services/affiliateService';

export const useAffiliateMetrics = (params?: { month?: number; year?: number }) => {
  return useQuery({
    queryKey: ['affiliate', 'metrics', params],
    queryFn: () => affiliateService.getMetrics(params),
  });
};
